<div class="bar" :style="{ width: p + '%', 'background': 'linear-gradient(0deg, rgba(20,20,20,1) 0%, ' + c + ' 100%)'}">{{ t }}<img :src="i"></div>